import React, { PureComponent } from 'react';
import { object } from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';

const Root = styled.div`
  background-color: ${colors.blite};
  padding: 6px 8px 8px;
  border-radius: 4px;
  line-height: 1;
`;

const Copy = styled.span`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.extraSmall};
`;

export default class HelpfulHint extends PureComponent {
  static propTypes = {
    insuranceCard: object,
  };

  hasError = () => {
    const { insuranceCard } = this.props;
    return insuranceCard.front.error || insuranceCard.back.error;
  };

  render = () => (
    <Collapse in={this.hasError()} timeout="auto" appear>
      <Root>
        <Copy>
          We couldn't quite read everything on your card. Please fill out your information below
        </Copy>
      </Root>
    </Collapse>
  );
}
